module.exports = __webpack_public_path__ + "static/media/dashboard-squiggles.c2f1506d.svg";